module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    ref: "headLeft",
    staticClass: "header-left"
  }), _vm._v(" "), _c('div', {
    ref: "headCenter",
    staticClass: "header-center",
    style: ({
      'background-image': 'url(' + require('./center-bg-data.js').default.data + ')'
    })
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    ref: "headRight",
    staticClass: "header-right"
  }), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "eagle-logo",
    attrs: {
      "src": require("./eagle-logo.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "eagle-text"
  }, [_vm._v("北京北森云计算鹰眼监控系统")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51aa1b30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/header/index.vue
// module id = 235
// module chunks = 0